import { useCallback, useEffect, useState } from "react";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import Menu from "../../../components/Menu";

import api from "../../../services/api";
import Loading from "../../../components/Loading";

export default function EstoqueFiacao() {
    const [data, setData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const formatNumber = (rowData, props)=> {
        return Intl.NumberFormat('pt-Br', { maximumFractionDigits: 0 }).format(rowData[props.field]);
    }

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("estoque-fiacao").then((response) => {
            setIsLoading(false);
            setData(response.data);
        }).catch((error) => {
            setIsLoading(false);
            setData([]);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Card
                className="p-m-1"
                title="Estoque da Fiação"
            >
                <div className="p-d-flex p-flex-row p-jc-end">

                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="Título" field="titulo" sortable />
                    <Column header="Peso (kg)" field="peso" sortable body={formatNumber} />
                    <Column header="Paletes" field="qtde" sortable body={formatNumber} />
                </DataTable>
            </Card>
        </div>
    )
}